export default "__VITE_ASSET__dRQYzNLY__"